import script from "./CollageTileHorizontalSliderTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollageTileHorizontalSliderTile.vue?vue&type=script&lang=ts&setup=true"

import "./CollageTileHorizontalSliderTile.vue?vue&type=style&index=0&id=8e104472&lang=less"

const __exports__ = script;

export default __exports__